import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../scss/button.scss';

function ConsentCheck() {
    const navigate = useNavigate();

    const { consentData } = useSelector((state) => state.bank);

    const { fip_ids, mobile_number, organisation_id, reference_id, tracking_id, data_details, vua_id, account_aggregator_id, return_url } = consentData

    const oneMoneyUrl = 'https://microapps.onemoney.in/sdk/stdsdk/v1/';
    const returnToAppSuccess = 'https://www.stashfin.com?returnToApp&success=1';
    const returnToAppFailure = 'https://www.stashfin.com?returnToApp&success=0';

    const onLoaded = () => {
        const iframe = document.getElementById("inner");
        if (!iframe) return;

        const payload = {
            consentHandle: [...reference_id],
            mobileNumber: mobile_number,
            fipId: fip_ids,
            organisationId: organisation_id,
            referenceId: reference_id,
            trackingId: tracking_id,
            dataDetails: data_details,
            vuaId: vua_id,
            accountAggregatorId: account_aggregator_id
        };

        iframe.contentWindow?.postMessage(payload, oneMoneyUrl);

        window.addEventListener("message", (event) => {
            if (event.origin !== new URL(oneMoneyUrl).origin) return;

            if (event.data?.success) {
                const { eventCode } = event.data.request || {};

                if (eventCode === "INVALID-CONSENT-HANDLE") {
                    payload.consentHandle = reference_id;
                }

                if (eventCode === "NO-ACCOUNTS-FOUND" || eventCode === "FIP-FAILED") {
                    navigate(-1);
                }

                if (eventCode === "CONSENT-APPROVED-SUCCESS") {
                    window.location.href = return_url || returnToAppSuccess;
                }

                if (
                    eventCode === "CONSENT-REJECTED-SUCCESS" ||
                    eventCode === "CONSENT-APPROVED-FAILED" ||
                    eventCode === "CONSENT-REJECTED-FAILED"
                ) {
                    window.location.href = return_url || returnToAppFailure;
                }
            }
        });
    };

    useEffect(() => {
        return () => {
            window.removeEventListener("message", () => { });
        };
    }, []);

    return (
        <div className='external-wrapper verify-bank retrive-statement statement-page'>
            <div className="iframe">
                <iframe
                    title="oneMoney"
                    onLoad={onLoaded}
                    width="100%"
                    id="inner"
                    src={oneMoneyUrl}
                />
            </div>
        </div>
    );
}

export default ConsentCheck;
